import React, { useEffect, useState,Suspense } from "react";
import axios from "axios";
const ContributorsDonationData = React.lazy(() => import('pages/donate-us/donation-carousal'));

export interface ApiResponse {
  heading: string;
  description: string;
}
export default function Contributors() {
  const [data, setData] = useState<ApiResponse | null>(null);

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_LOCAL_URL}/api/content/68efdc752d25c3fab3031fe9`
        );
        
        const apiData: ApiResponse = response.data.data;

        setData(apiData);
      } catch (error) {
        console.log(error);
      }
    };

    fetchDetails();
  }, []);

  return (
    <>
      <section className="blade-top-padding-lg  bg-[#FAF9F5] relative overflow-hidden">
   
        <h1 className="sm:w-container-xl text-[#07393C] font-lato-bold sm:text-left text-center w-container">
          {data?.heading}
          <hr className="h-[1px] hidden border-b sm:block" />
          <h4 className=" text-black font-lato-regular mt-6 2xl:leading-[34.98px] sm:text-left text-center">
            {data?.description}
          </h4>
        </h1>
        <div className="blade-bottom-padding">
          <Suspense fallback={<div className="text-center py-10"></div>}>
        <ContributorsDonationData />
      </Suspense>
        </div>
      </section>
    </>
  );
}
